import { createSlice } from '@reduxjs/toolkit';

import axios from 'axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    personaList: null,
    goalList: null,
    campaign: null,
    customThemeImagePath: null
};

// ==============================|| SLICE - CAMPAIGN DETAIL ||============================== //

const slice = createSlice({
    name: 'campaignDetail',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else {
                state.error = action.payload;
            }
        },
        setFormProperty(state, action) {
            state.personaList = action.payload.personaList;
            state.goalList = action.payload.campaignGoalList;
        },
        setCampaign(state, action) {
            state.campaign = action.payload;
        },
        setCustomThemeImage(state, action) {
            state.customThemeImagePath = action.payload;
        },
        resetCustomThemeImage(state) {
            state.customThemeImagePath = null;
        },
        reset(state) {
            state.error = null;
            state.personaList = null;
            state.goalList = null;
            state.campaign = null;
            state.customThemeImagePath = null;
        }
    }
});

export default slice.reducer;

export function clearStore(data, callback) {
    return () => {
        dispatch(slice.actions.reset());
        if (callback) {
            callback();
        }
    };
}

export function getCampaignFormProperty(data, callback) {
    return async () => {
        try {
            const response = await axios.post(
                '/api/properties/list',
                {},
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                        'X-Workspace-ID': localStorage.getItem('workspaceId')
                    }
                }
            );
            dispatch(slice.actions.setFormProperty(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getCampaignDetail(data, callback) {
    return async () => {
        try {
            const response = await axios.get(`/api/campaign/details/${data}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCampaign(response.data.campaign));
            if (response.data.campaign?.customTheme) {
                dispatch(slice.actions.setCustomThemeImage(response.data.campaign.customTheme));
            }
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function createCampaign(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/create', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCampaign(response.data.campaign));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function regenerateCampaign(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/campaign/regenerate', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCampaign(response.data.campaign));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function customThemeImageUpload(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/file/upload/temp', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'Content-Type': 'multipart/form-data',
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.setCustomThemeImage(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function removeCustomThemeImage(data, callback) {
    return () => {
        dispatch(slice.actions.resetCustomThemeImage());
        if (callback) {
            callback();
        }
    };
}
